import { updateItemInCollection } from "directus/src/operations";

export async function updateSurvey({ item, surveyId }) {
  try {
    const data = await updateItemInCollection("surveys", surveyId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
